/* Do not edit these strings. They are generated by ptmessages.js.php */
ptMessages = {
    "partnerdownloadbookmark": "Did you already create a bookmark for this page? Press <CTRL> + D to add a bookmark.",
    "applyunload": "You have not submitted the full application for the trial yet.",
    "equaltocaseinsensitivemsg": "Please enter the same value again.",
    "distanceunitmiles": "Miles",
    "distanceunitkilometers": "Kilometers",
    "distanceperyearlabel": " per year",
    "hours": "hours",
    "priceinterval3": "(billed every 3 months)",
    "priceinterval12": "(billed annually)",
    "priceinterval36": "(billed every 36 months)",
    "enterprise": "Enterprise",
    "enthintbuymore": "As of 2 field rep licenses:",
    "enthintusermgmt": "Central user management",
    "enthintrights": "Permissions management",
    "enthintorgsettings": "Company-wide settings",
    "enthintapi": "Data import and export via API",
    "enthintodata": "Data analysis via Excel and OData",
    "enthintadmins": "Free admin accounts",
    "shopbuysub": "for {invoiceamountinclvat} every {billinginterval} months until cancelled",
    "shopvatsub": "The amount includes {vatrate}% VAT ({vatamount}).<br\/>This will be displayed on the invoice.",
    "shopprice": "Price",
    "shoppriceincurrency": "Price in {currency}",
    "shopcurrencysub": "All prices in {currency}",
    "shopvatnotapplicable": "{vatamount} VAT ({vatrate}%) will be added to my invoice.",
    "shopordersumvatsub": "{totalincl} incl. {vatrate}% VAT",
    "shopmindatevalidate": "Date must be equal or greater than {2}.",
    "enthintbuyevenmore": "As of 10 field rep licenses:",
    "enthintusergroups": "User groups",
    "etrackerstatus": "Status:",
    "etrackeractive": "etracker is activated.",
    "etrackerinactive": "etracker is deactivated.",
    "etrackeroptin": "Activate etracker",
    "etrackeroptout": "Deactivate etracker",
    "brPhoneErrorMessage": "Please enter a valid phone number (10 or more digits)",
    "integererror": "Enter only whole numbers",
    "initvatnrlabel": "UID\/VAT Nr.",
    "ptSimpleForm_date": "Please provide a valid date",
    "ptSimpleForm_mindate": "Date must be equal or greater than {calculatedMinDate}",
    "ptSimpleForm_noWeekends": "Please select working days only",
    "ibanErrorMessage": "Please specify a valid IBAN."
};
